import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=4f4ff05f&"
import script from "./CompanyPage.vue?vue&type=script&lang=js&"
export * from "./CompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4ff05f')) {
      api.createRecord('4f4ff05f', component.options)
    } else {
      api.reload('4f4ff05f', component.options)
    }
    module.hot.accept("./CompanyPage.vue?vue&type=template&id=4f4ff05f&", function () {
      api.rerender('4f4ff05f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/CompanyPage.vue"
export default component.exports